
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"124.999","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2213"}},[_c('path',{attrs:{"data-name":"Rectangle 2935","fill":"none","d":"M0 0h124.999v120H0z"}}),_c('path',{attrs:{"data-name":"Path 1341","d":"M124.999 51.922L98.876 25.799a5.644 5.644 0 00-4.212-1.8 45.041 45.041 0 00-29.418 10.446 4.282 4.282 0 00-1.567 3.234v1.688l-4.926-4.925a45.043 45.043 0 00-29.418-10.446c-2.945 0-5.336 2.051-5.336 4.578v53.743a4.265 4.265 0 001.623 3.276l34.4 34.4h64.974z","fill":"#1c3e59"}}),_c('path',{attrs:{"data-name":"Union 22","d":"M66.98 95.653a4.639 4.639 0 01-3.3-4.227V37.68a4.281 4.281 0 011.567-3.234A45.041 45.041 0 0194.664 24c2.946 0 5.335 2.051 5.335 4.578v53.743c0 2.527-2.389 4.575-5.335 4.575a33.49 33.49 0 00-21.867 7.766A5.828 5.828 0 0169.02 96a6.139 6.139 0 01-2.04-.347zm-15.777-.992a33.46 33.46 0 00-21.867-7.766c-2.941 0-5.336-2.047-5.336-4.575V28.578C24 26.051 26.395 24 29.336 24a45.045 45.045 0 0129.417 10.446 4.266 4.266 0 011.567 3.234v53.746a4.64 4.64 0 01-3.3 4.227 6.143 6.143 0 01-2.039.346 5.831 5.831 0 01-3.778-1.338z","fill":"#4b8baf"}})])])
          )
        }
      }
    